const EditInput = ({ label, type = "number", onChange, value, disabled = false, children }) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
        {label}
      </label>
      {children || (
        <input
          className={`w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-100 transition-all outline-none ${disabled ? "bg-gray-50 cursor-not-allowed" : ""}`}
          type={type}
          onChange={onChange}
          value={value}
          disabled={disabled}
        />
      )}
    </div>
  )
}

export default EditInput
